import React, { useEffect, useState } from 'react';
import NotificationsIcon from '@mui/icons-material/Notifications';
import MoreIcon from '@mui/icons-material/MoreVert';
import Divider from '@mui/material/Divider';
import { logOut } from '../../Requests/AuthService';
import { useNavigate } from 'react-router-dom';
import { getNotifications, updateNotificationStatus } from '../../Requests/NotificationService.ts';
import { getCurrentAdmin } from '../../Requests/AuthService';
import { Avatar, AppBar, Box, Toolbar, IconButton, Typography, Badge, MenuItem, Menu, Button } from '@mui/material';
import { Close } from '@mui/icons-material';
import { GRAY2 } from '../StyledComponents/Color/Color';
import AddModalView from "../AddModalView/AddModalView";
import EmailConfigurationView from '../EmailConfiguration/Email ConfigurationView';
import NotificationConfigurationView from '../NotificationConfiguration/NotificationConfiguration.tsx';
import dayjs from "dayjs";
import NotificationTimeBeforeEventView from '../NotificationConfiguration/NotificationTimeBeforeEventView.tsx';


export default function Header() {
  const navigate = useNavigate()
  const [notifications, setNotifications] = useState([])

  const [anchorEl, setAnchorEl] = useState(null)
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null)
  const [notificationAnchorEl, setNotificationAnchorEl] = useState(null)

  const isMenuOpen = Boolean(anchorEl)
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl)
  const isNotificationMenuOpen = Boolean(notificationAnchorEl)

  const [isOpenNotivicationSettingsModal, setIsOpenNotivicationSettingsModal] = useState(false)
  const [isOpenNotivicationConfigurationModal, setIsOpenNotivicationConfigurationModal] = useState(false)
  const [isOpenEmailSettingsModal, setIsOpenEmailSettingsModal] = useState(false)
  const [selectedAlertTab, setSelectedAlertTab] = useState("all")

  useEffect(() => {
    fetchData()
  }, [])

  async function fetchData() {
    const result = await getNotifications()
    setNotifications(result)
  }

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget)
  }

  const handleNotificationMenuOpen = (event) => {
    setNotificationAnchorEl(event.currentTarget)
    setSelectedAlertTab("all")
  }

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null)
  }

  const handleNotificationMenuClose = () => {
    setNotificationAnchorEl(null)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
    handleMobileMenuClose()
    handleNotificationMenuClose()
  }

  function handleLogout() {
    handleMenuClose()
    logOut()
    navigate("/login")
  }

  const handleMarkAsRead = async (id) => {
    // Оптимистично убираем уведомление из списка сразу
    setNotifications((prev) => prev.filter((n) => n.id !== id))

    try {
      await updateNotificationStatus(id)
    } catch (e) {
      // В случае любой ошибки (кроме "Object not found." — она уже гасится в сервисе)
      // просто пересинхронизируем список, чтобы не оставить UI в нек konsistentном состоянии
      fetchData()
    }
  }

  const inferCategory = (notification) => {
    if (notification?.category) {
      return String(notification.category).toLowerCase()
    }

    const text = String(notification?.text || "").toLowerCase()
    if (
      text.includes("registered for") ||
      text.includes("interested in the event") ||
      text.includes("stopped being interested") ||
      text.includes("left feedback")
    ) {
      return "events"
    }

    if (
      text.includes("membership") ||
      text.includes("signed up to the app") ||
      text.includes("signed in")
    ) {
      return "membership"
    }

    return "insights"
  }

  const unreadNotifications = notifications.filter((n) => !n.isRead)
  const filteredNotifications = selectedAlertTab === "all"
    ? unreadNotifications
    : unreadNotifications.filter((notification) => inferCategory(notification) === selectedAlertTab)

  const alertTabs = [
    { id: "all", title: "All alerts" },
    { id: "events", title: "Events" },
    { id: "membership", title: "Membership" },
    { id: "insights", title: "Insights" }
  ]

  const menuId = 'primary-search-account-menu'
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={() => setIsOpenNotivicationSettingsModal(true)}>Send message</MenuItem>
      <MenuItem onClick={() => setIsOpenNotivicationConfigurationModal(true)}>Notification Configuration</MenuItem>
      <MenuItem onClick={() => setIsOpenEmailSettingsModal(true)}>Email Configuration</MenuItem>
      <MenuItem onClick={handleLogout}>Logout</MenuItem>
    </Menu>
  )

  const mobileMenuId = 'primary-search-account-menu-mobile'
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem onClick={handleNotificationMenuOpen}>
        <IconButton
          size="large"
          color="inherit"
        >
          <Badge badgeContent={notifications.filter(n => !n.isRead).length} color="error">
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <Avatar
            src={getCurrentAdmin().image}
            sx={{ width: 24, height: 24 }}
          />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  )

  const notificationMenuId = 'primary-search-notification-menu'
  const notificationRenderMenu = (
    <Menu
      anchorEl={notificationAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={notificationMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isNotificationMenuOpen}
      onClose={handleMenuClose}
      sx={{
        "& .MuiMenu-paper": {
          backgroundColor: GRAY2,
          width: "min(620px, calc(100vw - 32px))",
          maxWidth: "620px",
          maxHeight: "calc(100vh - 96px)",
          borderRadius: "22px",
          p: 0,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column"
        }
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100%",
          minHeight: 0
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontSize: "40px",
            lineHeight: 1.1,
            fontWeight: 500,
            px: 4,
            pt: 3.5,
            pb: 3
          }}
        >
          Alerts
        </Typography>

        <Divider />

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            px: 4,
            py: 2
          }}
        >
          {alertTabs.map((tab) => (
            <Button
              key={tab.id}
              disableRipple
              onClick={() => setSelectedAlertTab(tab.id)}
              sx={{
                borderRadius: "999px",
                px: 2.25,
                py: 0.7,
                color: "#606060",
                textTransform: "none",
                fontSize: "15px",
                lineHeight: 1.2,
                backgroundColor: selectedAlertTab === tab.id ? "#DCDCDC" : "transparent",
                "&:hover": {
                  backgroundColor: selectedAlertTab === tab.id ? "#DCDCDC" : "rgba(0, 0, 0, 0.04)"
                }
              }}
            >
              {tab.title}
            </Button>
          ))}
        </Box>

        <Divider />

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            minHeight: 0
          }}
        >
          {filteredNotifications.map((notification) => (
            <Box key={notification.id}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 2,
                  px: 4,
                  py: 2.3
                }}
              >
                <Avatar
                  src={notification?.user?.avatar}
                  sx={{
                    width: 42,
                    height: 42,
                    mt: 0.4
                  }}
                />

                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      lineHeight: 1.35,
                      fontWeight: 400,
                      color: "#202020",
                      wordBreak: "break-word"
                    }}
                  >
                    {notification.text}
                  </Typography>
                  <Typography
                    sx={{
                      mt: 0.9,
                      fontSize: "13px",
                      lineHeight: 1.2,
                      color: "#606060"
                    }}
                  >
                    {dayjs(notification.createdAt).format('DD MMM YYYY, HH:mm')}
                  </Typography>
                </Box>

                <IconButton
                  disableRipple
                  onClick={() => handleMarkAsRead(notification.id)}
                  sx={{
                    mt: 0.5,
                    width: 40,
                    height: 40,
                    backgroundColor: "#E8E8E8",
                    "&:hover": {
                      backgroundColor: "#E1E1E1"
                    }
                  }}
                >
                  <Close
                    sx={{
                      width: 22,
                      height: 22,
                      color: "#7A7A7A"
                    }}
                  />
                </IconButton>
              </Box>
              <Divider />
            </Box>
          ))}

          {filteredNotifications.length === 0 && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flex: 1,
                px: 3
              }}
            >
              <Typography
                sx={{
                  fontSize: "17px",
                  color: "#606060",
                  textAlign: "center"
                }}
              >
                You&apos;re all caught up — no new alerts
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Menu>
  )

  return (
    <>
      <Box>
        <AppBar
          position="fixed"
          color="transparent"
          sx={{
            boxShadow: "none",
            background: GRAY2,
            top: 0,
            zIndex: "999",
            overscrollBehavior: "contain",
            width: "100%"
          }}
        >
          <Toolbar>
            <Typography
              variant="h6"
            >
              Quorum Network
            </Typography>

            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
              <IconButton
                size="large"
                color="inherit"
                onClick={handleNotificationMenuOpen}
              >
                <Badge badgeContent={notifications.filter(n => !n.isRead).length} color="error">
                  <NotificationsIcon />
                </Badge>
              </IconButton>
              <IconButton
                size="large"
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleProfileMenuOpen}
                color="inherit"
              >
                <Avatar
                  src={getCurrentAdmin().image}
                  sx={{ width: 32, height: 32 }}
                />
              </IconButton>
            </Box>
            <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
              <IconButton
                size="large"
                aria-label="show more"
                aria-controls={mobileMenuId}
                aria-haspopup="true"
                onClick={handleMobileMenuOpen}
                color="inherit"
              >
                <MoreIcon />
              </IconButton>
            </Box>
          </Toolbar>
        </AppBar>
        {renderMobileMenu}
        {renderMenu}
        {notificationRenderMenu}
        <Divider />
      </Box>

      <AddModalView
        isOpen={isOpenEmailSettingsModal}
        setIsOpen={setIsOpenEmailSettingsModal}
        title={"Email Configuration"}
        view={
          <EmailConfigurationView
            publish={() => {
              setIsOpenEmailSettingsModal(false)
            }} />
        }
      />

      <AddModalView
        isOpen={isOpenNotivicationSettingsModal}
        setIsOpen={setIsOpenNotivicationSettingsModal}
        title={"Send message"}
        modalSx={{
          width: 552,
          maxWidth: "calc(100vw - 32px)",
          height: "min(1001px, calc(100vh - 32px))",
          bgcolor: "#FCFCFC",
          border: "1px solid #D9D9D9",
          borderRadius: "32px",
          boxShadow: "0px 24px 80px rgba(32, 32, 32, 0.16)"
        }}
        headerSx={{
          minHeight: "64px",
          height: "64px",
          px: 3,
          py: "10px",
          bgcolor: "#F9F9F9",
          borderBottom: "1px solid #D9D9D9"
        }}
        titleVariant={"body1"}
        titleSx={{
          color: "#202020",
          fontSize: "20px",
          fontWeight: 500,
          lineHeight: "28px"
        }}
        showDivider={false}
        view={<NotificationConfigurationView />}
      />

      <AddModalView
        isOpen={isOpenNotivicationConfigurationModal}
        setIsOpen={setIsOpenNotivicationConfigurationModal}
        title={"Notification Configuration"}
        view={
          <NotificationTimeBeforeEventView
            publish={() => {
              setIsOpenNotivicationConfigurationModal(false)
            }} />
        }
      />
    </>
  )
}
